// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","qacard":"ByI2o8","index":"hLsmES","AniFadeIn":"wFucWw","AniFadeOut":"ImtG0_","AniRotate":"g_0cYI","AniPlaceholderFadeOut":"veYmsh"};